import React from 'react';
import styles from './CircleColor.module.scss'
import {Color} from "../../../../../store/types/store";

interface CircleColorProps {
    color: Color
    isActive: boolean
}

const CircleColor = ({color, isActive, ...props} : React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & CircleColorProps) => {
    return <div className={[styles.circle, styles[color], isActive && styles.active].join(' ')} {...props}/>
};

export default CircleColor;